import { getApi } from '@/stores/api'
import type { SwitchableModule } from '@repo/permissions'

/**
 * Each module mounts its own my-uploads router on its own upload log. The page's module picks the
 * router, so the request carries no module and the backend never has to trust one: a wrong pick is
 * a visibly wrong URL that the other module's permission refuses.
 */
export function getMyUploadsApi(module: SwitchableModule) {
  const api = getApi()

  switch (module) {
    case 'core':
      return api['my-uploads']
    case 'crt':
      return api.crt['my-uploads']
    case 'credit':
      return api.credit['my-uploads']
  }
}

/** The same routers as plain paths, for the CSV export which is fetched outside the typed client. */
export const MY_UPLOADS_API_PATH: Record<SwitchableModule, string> = {
  core: '/my-uploads',
  crt: '/crt/my-uploads',
  credit: '/credit/my-uploads',
}
